import React from 'react';
import { Toaster as Sonner } from 'sonner';
import { Icons } from '../Icons';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      loadingIcon={<Icons.LoadingSpinner />}
      icons={{
        warning: <Icons.StatusWarning />,
        info: <Icons.Info className="text-[#7dbae7]" />,
        success: <Icons.StatusSuccess />,
        error: <Icons.StatusError />,
      }}
      theme="dark"
      toastOptions={{
        style: {
          width: '430px', // Set a maximum width
          right: '8px',
        },
        classNames: {
          toast:
            '!items-start !gap-2.5 !rounded-lg !border !border-[hsl(216_24%_22%)] !bg-[hsl(216_32%_13%)] !px-3 !py-3 !text-[hsl(210_25%_94%)] !shadow-[0_12px_32px_rgba(0,0,0,.5)]',
          title: '!text-[13px] !font-medium !leading-5',
          description: '!text-[12px] !leading-4 !text-[hsl(214_18%_72%)]',
          closeButton:
            '!border-[hsl(216_24%_22%)] !bg-[hsl(216_32%_13%)] !text-[hsl(214_18%_72%)] hover:!bg-[hsl(216_28%_18%)]',
          actionButton: '!rounded-md !bg-[#1e78b8] !text-white hover:!bg-[#0f63a0]',
          cancelButton:
            '!rounded-md !border !border-[hsl(216_18%_38%)] !bg-transparent !text-[hsl(210_25%_94%)]',
          success: '!border-[hsl(145_35%_30%)] [&_[data-icon]]:!text-[hsl(145_55%_65%)]',
          error: '!border-[hsl(0_45%_34%)] [&_[data-icon]]:!text-[hsl(0_85%_76%)]',
          warning: '!border-[hsl(35_50%_32%)] [&_[data-icon]]:!text-[hsl(35_92%_70%)]',
          info: '!border-[hsl(206_50%_32%)] [&_[data-icon]]:!text-[#7dbae7]',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
